export default "__VITE_ASSET__6b724a0c__"